import React from 'react';
import { connect } from 'react-redux'

const kennitala = require('kennitala')
import { fetchCustomer, addEmptyCustomer } from '../../api/customers/actions'
import { formatKennitala } from '../../utils'
import connectWithStore from '../../utils/store'

import { store } from '../../store'
import { fetchCurrency } from '../../api/currency/actions';
import { setCurrency } from '../../api/gui/actions';
import { SvgAddIcon, SvgCheckIcon } from '../svg';

class CustomerLookup extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            search: "",
            currencyValue: "",
        }

        this.addEmptyCustomer = this.addEmptyCustomer.bind(this)
        this.search = this.search.bind(this)
        this.changeCurrency = this.changeCurrency.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(fetchCurrency("EUR"))
        initialInputState();
    }

    handleSSN(event) {
        if (this.props.allowCompanies) {
            if (kennitala.isValid(event.target.value)) {
                this.props.dispatch(fetchCustomer(kennitala.clean(event.target.value)))
            }
        } else {
            if (kennitala.isValid(event.target.value) && kennitala.isPerson(event.target.value)) {
                this.props.dispatch(fetchCustomer(kennitala.clean(event.target.value)))
            }
        }

        this.setState({ search: event.target.value })
    }

    renderName() {
        if (this.props.customers.isFetching || Object.keys(this.props.customers.lastLookup).length === 0) {
            return ""
        } else {
            return this.props.customers.lastLookup.Customer.Name
        }
    }

    changeCurrency(evt) {
        this.setState({ currencyValue: evt.target.value })
        this.props.dispatch(setCurrency(evt.target.value))
    }

    search(customerId) {
        this.setState({ search: customerId })
        this.props.dispatch(fetchCustomer(kennitala.clean(customerId)))
    }

    addEmptyCustomer(person) {
        this.props.dispatch(addEmptyCustomer(person))
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        initialInputState();
        if (prevProps.currency.isFetching !== this.props.currency.isFetching && this.props.currency.isFetching === false) {
            this.setState({ currencyValue: this.props.currency.value })
            this.props.dispatch(setCurrency(this.props.currency.value))
        }
    }

    displayAppropriateIcon(customers, person) {
        if (customers && customers.customerList.length > 0) {
            let accountNumbers = customers.customerList.map(customer => {
                return customer.Customer.AccountNum
            })
            if (accountNumbers.includes(person.OrgId)) {
                return (
                    <button type="button" className="check" onClick={() => this.addEmptyCustomer(person)} >
                        <SvgCheckIcon />
                    </button>
                )
            } else {
                return (
                    <button type="button" className="add" onClick={() => this.addEmptyCustomer(person)} >
                        <SvgAddIcon />
                    </button>
                )
            }
        } else {
            return (
                <button type="button" className="add" onClick={() => this.addEmptyCustomer(person)} >
                    <SvgAddIcon />
                </button>
            )
        }
    }

    render() {
        let customers = this.props.customers;

        return (
            <div className="card quote-form step-1">
                <div className="card-body">
                    <h5>Sláðu inn kennitölu viðskiptavinar</h5>
                    <form>
                        <div className="row">
                            <div className="form-group col-8 pl-0">
                                <input id="quote-ssn" className="form-control" placeholder="Kennitala" value={this.state.search} type="text" onChange={this.handleSSN.bind(this)} autoFocus />
                                {/* <label htmlFor="quote-ssn">Kennitala</label> */}
                            </div>
                            <div className="form-group col-4 mt-0 pr-0 currency">
                                <input id="quote-exchangerate" type="text" className="form-control" onChange={this.changeCurrency} value={this.state.currencyValue} />
                                <label htmlFor="quote-exchangerate">Gengi</label>
                            </div>
                        </div>
                        {this.props.nationalRegistry.data.length > 0 &&

                            <>
                                <h5 className="xs-mb-10 xs-mt-10">Niðurstöður úr Þjóðskrá</h5>
                                <div className="row">
                                    <div className="col-12 client-container">
                                        <ul className="client">
                                            {this.props.nationalRegistry.data.map((person, key) =>
                                                <li key={key}>
                                                    <span className="name">
                                                        <span>{person.Name} </span>
                                                        <span>({formatKennitala(person.OrgId)})</span>
                                                        <strong> {person.Fate !== "4" && <>{person.FateTxt}</>}</strong>
                                                    </span>
                                                    { person.Fate === "4" &&
                                                        <>{this.displayAppropriateIcon(customers, person)}</>
                                                    }
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </>
                        }

                    </form>
                </div>
            </div>


        )
    }
}

CustomerLookup.defaultProps = {
    allowCompanies: false
}


function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        currency: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.currency = (state.currency === undefined) ? {} : state.currency
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    return f;
}


export default connectWithStore(store, CustomerLookup, mapStateToProps);